import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Source, Status } from '../modules/shared/models';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
  standalone: false,
})
export class FilterDialogComponent implements OnInit{
  filterForm: FormGroup = new FormGroup({});
  constructor(public dialogRef: MatDialogRef<FilterDialogComponent>,private fb: FormBuilder) {}
    public Status = Status;
    public Source = Source;

  onCancel(): void {
    console.log('Cancel button clicked');
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      filter: ['Due Date' ],
      search: ['', ],
        RAG: this.fb.group({
    Red: [false],
    Grey: [false],
    Amber: [false],
      Green: [false]
    }),
    })

    this.filterForm.get('filter')?.valueChanges.subscribe((value) => {
      console.log('Selected filter:', value); // Debugging log
      // Reset search and RAG checkboxes when switching filter type
      this.filterForm.get('search')?.reset('');
      this.filterForm.get('RAG')?.reset({ Red: false, Grey: false, Amber: false, Green: false });
    });
  }
  get Red() {
    return this.filterForm.get('RAG.Red') as FormControl;
  }
  get Grey() {
    return this.filterForm.get('RAG.Grey') as FormControl;
  }
  get Amber() {
    return this.filterForm.get('RAG.Amber') as FormControl;
  }
  get Green() {
    return this.filterForm.get('RAG.Green') as FormControl;
  }
 
  onApply(): void {
    if (this.filterForm.valid) {
      const filterValues = this.filterForm.value;
      // To get selected rag colors as an array:
      const ragColorObj = filterValues.RAG;
      const selectedRagColors = Object.keys(ragColorObj).filter(key => ragColorObj[key]);
      console.log('Selected Rag Colors:', selectedRagColors);
      this.dialogRef.close({ ...filterValues, selectedRagColors });
      
    }
  }
}
